import React, { useEffect, useMemo, useState } from 'react';
import MasterService from '../services/master/MasterService';

const Kecamatan = ({ id }) => {
    let masterService = useMemo(() => new MasterService(), [])
    const [kecamatan, setKecamatan] = useState('')

    useEffect(() => {
        const getKecamatan = async () => {
            try {
                const response = await masterService.getKecamatanById(id)
                setKecamatan(response.data.uraianKecamatan)
            } catch (error) {
                setKecamatan('')
            }
        }
        getKecamatan()
    }, [masterService, id])

    return (
        <>
            {kecamatan}
        </>
    )
}

export default Kecamatan